var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDidDefinition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2857 36.2195V68.7857H62.5714V36.2195C62.5712 36.2125 62.5707 36.1978 62.5696 36.1758C62.5669 36.124 62.5607 36.0326 62.5468 35.9071C62.5189 35.6556 62.4604 35.2721 62.3385 34.801C62.0943 33.8575 61.6022 32.5858 60.611 31.3093C58.6984 28.8461 54.5759 25.9285 45.4286 25.9285C36.2812 25.9285 32.1587 28.8461 30.2461 31.3093C29.2549 32.5858 28.7629 33.8575 28.5187 34.801C28.3968 35.2721 28.3382 35.6556 28.3103 35.9071C28.2964 36.0326 28.2902 36.124 28.2876 36.1758C28.2864 36.1977 28.2859 36.2124 28.2857 36.2195ZM26.1429 36.2045H24V70.9285C24 72.112 24.9594 73.0714 26.1429 73.0714H64.7143C65.8978 73.0714 66.8572 72.112 66.8572 70.9285V36.2045H64.7143C66.8572 36.2045 66.8572 36.2028 66.8571 36.2011L66.8571 36.1974L66.8571 36.1891L66.8569 36.1691L66.8559 36.1152C66.8548 36.0733 66.8529 36.0194 66.8496 35.9543C66.8428 35.8241 66.8302 35.6488 66.8064 35.4346C66.759 35.0071 66.6669 34.4203 66.4875 33.7271C66.129 32.3421 65.4156 30.5091 63.9961 28.6809C61.0873 24.9347 55.567 21.6428 45.4286 21.6428C35.2902 21.6428 29.7698 24.9347 26.861 28.6809C25.4415 30.5091 24.7282 32.3421 24.3697 33.7271C24.1903 34.4203 24.0982 35.0071 24.0507 35.4346C24.027 35.6488 24.0143 35.8241 24.0076 35.9543C24.0042 36.0194 24.0023 36.0733 24.0013 36.1152L24.0002 36.1691L24 36.1892L24 36.1974L24 36.2011C24 36.2028 24 36.2045 26.1429 36.2045Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4284 32.3572C43.0614 32.3572 41.1426 34.276 41.1426 36.643C41.1426 39.0099 43.0614 40.9287 45.4284 40.9287C47.7953 40.9287 49.7141 39.0099 49.7141 36.643C49.7141 34.276 47.7953 32.3572 45.4284 32.3572ZM36.8569 36.643C36.8569 31.9091 40.6945 28.0715 45.4284 28.0715C50.1622 28.0715 53.9998 31.9091 53.9998 36.643C53.9998 41.3768 50.1622 45.2144 45.4284 45.2144C40.6945 45.2144 36.8569 41.3768 36.8569 36.643Z",
    fill: "#BAE047",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4285 12C46.612 12 47.5714 12.9594 47.5714 14.1429V30.2143C47.5714 31.3978 46.612 32.3571 45.4285 32.3571C44.245 32.3571 43.2856 31.3978 43.2856 30.2143V14.1429C43.2856 12.9594 44.245 12 45.4285 12Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDidDefinition);
export default __webpack_public_path__ + "static/media/did-definition.f9dc0353166f15e8c50b380acd71925f.svg";
export { ForwardRef as ReactComponent };